exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._328JN {\n  padding: 100px 24px;\n  background: #f9fafa;\n}\n\n._2jMSp {\n  max-width: 1160px;\n  margin: 0 auto;\n}\n\n._1OYUD {\n  text-align: center;\n  font-size: 34px;\n  font-weight: 800;\n  color: #1a1a1a;\n  line-height: 1.25;\n  margin: 0 0 56px;\n}\n\n._3_upg {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  grid-gap: 64px;\n  gap: 64px;\n}\n\n.pyy-8 {\n  -ms-flex: 1 1 45%;\n      flex: 1 1 45%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n\n.pyy-8 img {\n  width: 100%;\n  max-width: 420px;\n  border-radius: 16px;\n}\n\n._2S_zj {\n  -ms-flex: 1 1 55%;\n      flex: 1 1 55%;\n}\n\n._1rbQL {\n  padding: 24px 0;\n  border-bottom: 1px solid #e6e6e6;\n}\n\n._1rbQL:last-child {\n  border-bottom: none;\n}\n\n._2g2zI {\n  font-size: 19px;\n  font-weight: 700;\n  color: #1a1a1a;\n  margin: 0 0 8px;\n}\n\n._9p-nU {\n  font-size: 14px;\n  color: #666;\n  line-height: 1.6;\n  margin: 0;\n}\n\n@media (max-width: 860px) {\n  ._3_upg {\n    -ms-flex-direction: column;\n        flex-direction: column;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"why": "_328JN",
	"inner": "_2jMSp",
	"heading": "_1OYUD",
	"content": "_3_upg",
	"left": "pyy-8",
	"list": "_2S_zj",
	"feature": "_1rbQL",
	"featureTitle": "_2g2zI",
	"featureText": "_9p-nU"
};